import { Box, Stack } from '@mui/material';

import { CollapsibleContent } from '@modules/_shared/components/CollapsibleContent';
import MarkdownParser from '@modules/_shared/components/MarkdownParser';
import EditableSectionHeader from '@modules/_shared/components/visibility-drawer/sections/EditableSectionHeader';
import type { SectionProps } from '@modules/_shared/components/visibility-drawer/types';
import { useLocale } from '@shared/hooks/locale';

const AboutSection = ({ entity, onEdit }: SectionProps) => {
  const { t } = useLocale();

  return (
    <EditableSectionHeader
      title={t('About')}
      onEdit={onEdit}
      interactiveChildren
    >
      <Stack direction="column">
        {!entity.description ? (
          <Box sx={{ color: 'text.secondary' }}>-</Box>
        ) : (
          <CollapsibleContent nbLinesToShow={8}>
            <Box
              sx={{
                color: 'text.secondary',
                typography: 'body2',
                '& p, ol, ul': {
                  marginTop: 0,
                  marginBottom: '1em',
                },
              }}
            >
              <MarkdownParser markdown={entity.description} />
            </Box>
          </CollapsibleContent>
        )}
      </Stack>
    </EditableSectionHeader>
  );
};

export default AboutSection;
